export default __webpack_public_path__ + "static/media/agder_ops_logo.8da417d2.svg";